import Button from 'components/base/Button';
import { getEntityId } from 'helpers/entityId';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { RepViewBreadcrumbItems } from 'data/commonData';
import { Col, Form, Row } from 'react-bootstrap';
import CreateStaffForm from 'components/forms/CreateStaffForm';
import { ChangeEvent, FormEvent, useState, useEffect } from 'react';
import {
  CreateRepFormData,
  updateRepDTO
} from 'data/from-data/create-customer-rep-form.data';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  GET_CUSTOMERS_REP,
  UPDATE_CUSTOMERS_REP
} from 'services/api/customer-rep';
import { FormProps } from 'data/from-data/interface/form-props.interface';
import { useNavigate } from 'react-router-dom';
import { Link, useParams } from 'react-router-dom';
import PhoenixLoader from 'components/common/PhoenixLoader';
import { toast } from 'react-hot-toast';
const EditRep = () => {
  const { id } = useParams<{ id?: string }>();
  const [validated, setValidated] = useState<boolean>(false);
  const [createCustomerDto, setCreateCustomerDto] = useState<CreateRepFormData>(
    new CreateRepFormData()
  );
  const [isLoading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const queries = useQueryClient();
  const getCustomerQuery = useQuery(['getRepresentative', id], () =>
    id ? GET_CUSTOMERS_REP(id) : Promise.reject('No id provided')
  );
  const updateCustomerAction = useMutation(
    'updateRepresentative',
    UPDATE_CUSTOMERS_REP,
    {
      onError: (err: any) => {
        setLoading(false);
        toast.error(err.response.data.messages || 'Something went wrong');
        console.log(err);
      },
      onSuccess: () => {
        setLoading(false);
        queries.invalidateQueries('get_customer_reps');
        navigate('/home/apps/representative');
        toast.success('Customer updated Successfully');
      },
      onMutate: () => {
        setLoading(true);
      }
    }
  );

  useEffect(() => {
    if (getCustomerQuery.isSuccess) {
      const { data: RepData }: any = getCustomerQuery.data;
      setCreateCustomerDto(prevData => {
        if (RepData !== null) {
          const updatedData = Object.keys(prevData).reduce((acc: any, key) => {
            if (key === 'client' && RepData[key]) {
              acc[key] = {
                ...prevData[key],
                value: {
                  _id: getEntityId(RepData[key]) || '',
                  organizationName: RepData[key].organizationName
                }
              };
            } else {
              acc[key] = {
                ...prevData[key],
                value: RepData[key] || prevData[key].value
              };
            }
            return acc;
          }, {});
          return updatedData;
        }
        return prevData;
      });
    }
  }, [getCustomerQuery.isSuccess, getCustomerQuery.data]);

  const handleSubmit = (event: FormEvent) => {
    const form = event.currentTarget as HTMLFormElement;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      return runFormSubmissionAction(event);
    }

    setValidated(true);
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setCreateCustomerDto(prevData => ({
      ...prevData,
      [name]: {
        ...prevData[name],
        value
      }
    }));
  };

  const runFormSubmissionAction = async (e: FormEvent) => {
    e.preventDefault();

    const {
      firstName: { value: firstName },
      lastName: { value: lastName },
      mobile: { value: mobile },
      phone: { value: phone },
      title: { value: title },
      email: { value: email },
      client: { value: client },
      notes: { value: notes }
    } = createCustomerDto;

    const clientId = typeof client === 'object' ? client.id : client;

    const payload: updateRepDTO = {
      firstName,
      lastName,
      mobile,
      phone,
      title,
      email,
      client: clientId,
      notes
    };
    await updateCustomerAction.mutateAsync({
      customerId: id,
      formData: payload as any
    });
  };
  const renderFormFields = () => {
    return (
      createCustomerDto &&
      Object.entries(createCustomerDto)?.map(([key, formProps]) => (
        <Col md="6" key={key}>
          <CreateStaffForm
            formProps={formProps as unknown as FormProps}
            handleInputChange={handleInputChange}
            isEditing={true}
          />
        </Col>
      ))
    );
  };
  return (
    <div className="mb-9">
      <PageBreadcrumb items={RepViewBreadcrumbItems} />
      <div className="border-bottom mb-7 mx-n3 px-2 mx-lg-n6 px-lg-6">
        <Row>
          <Col xl={9}>
            <div className="d-sm-flex justify-content-between">
              <h2 className="mb-4">Edit Representative</h2>
              <div className="d-flex mb-3">
                <Link to="/home/apps/representative">
                  <Button variant="phoenix-primary" className="me-2 px-6">
                    Cancel
                  </Button>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Row>
        <Col xl={9}>
          {getCustomerQuery.isLoading && <PhoenixLoader />}
          {getCustomerQuery.isSuccess && (
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <h4 className="mb-3">Edit Information</h4>
              <Row className="g-3 mb-8">{renderFormFields()}</Row>
              <div className="text-end">
                <Button
                  variant="primary"
                  className="mt-6"
                  type="submit"
                  disabled={isLoading}
                >
                  Update Customer
                </Button>
              </div>
            </Form>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EditRep;
